/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {Col} from "react-bootstrap";


type FormResetComponentProps = {
    formResetHandler(): void
};


export const FormResetComponent: React.FC<FormResetComponentProps> = ({formResetHandler}): JSX.Element | null => {

    if (!formResetHandler) return null;

    return (
        <Col xs={12} lg={3} className={"user-form-reset-component"}>
            <span onClick={formResetHandler} className={"user-form-reset"}>{`Resetuj formularz`}</span>
        </Col>
    );

};


export default FormResetComponent;
